import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';
import type ImputationSimulation from '../../interfaces/simulation/imputationSimulation';

const getRAR = (identifiant: number) =>
	request.get<any, TemplateRequestGet<ImputationSimulation>>(
		`/api/finances/simulation/imputationSimulation?identifiantSimulation=${identifiant}&rar=not(0)&perPage=1`,
	);

export default getRAR;
